module.exports = __webpack_public_path__ + "static/logo-planifeye-b0dd88874fbc8bc5f42d8b6c2eb73410.png";